var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-footer',{staticClass:"fixed-bottom"},[_c('p',{staticClass:"footer-copyright mb-0 py-3 text-center"},[_vm._v(" GWW Leadforge 4.0 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }